function NibbletAppIcon({ className = "", ...props }) {
  return (
    <img 
      src="https://res.cloudinary.com/dnpokb6ln/image/upload/v1760495803/nibblet-app-icon_ur218p.svg" 
      alt="nibblet icon" 
      className={className}
      {...props}
    />
  );
}

export default NibbletAppIcon;